import { NotificationsObservableFactory } from '../../core/notifications-observable/implementation';
import { GetSetSuperArgsFunction, IsFactoryClass, MakeFactory } from '../../../classes/class-helpers/factory';
import { BaseClass } from '../../../classes/class-helpers/base-class';
import { ObservableFactory } from '../../../core/observable/implementation';
import { IsNotificationsObservableConstructor } from '../../core/notifications-observable/constructor';
import { ExtractObserverNameAndCallback } from '../../core/notifications-observer/functions';
import { FINITE_STATE_OBSERVABLE_PRIVATE } from './privates';
import { ConstructFiniteStateObservable, IS_COMPLETE_STATE_OBSERVABLE_CONSTRUCTOR } from './constructor';
import { IsFiniteStateObservableFinalState, IsFiniteStateObservableNextState } from './functions';
export function FiniteStateObservableOnObserved(instance, observer) {
    const privates = instance[FINITE_STATE_OBSERVABLE_PRIVATE];
    if ((privates.mode === 'uniq')
        && (privates.state !== 'next')) {
        const result = ExtractObserverNameAndCallback(observer);
        if ((result !== null)
            && (IsFiniteStateObservableNextState(result.name)
                || IsFiniteStateObservableFinalState(instance, result.name))) {
            throw new Error(`Cannot observe this Observable because it is the state '${privates.state}'.`);
        }
    }
    for (let i = 0, l = privates.values.length; i < l; i++) {
        observer.emit(privates.values[i]);
    }
    privates.onObserveHook(observer);
}
export function FiniteStateObservableOnUnobserved(instance, observer) {
    instance[FINITE_STATE_OBSERVABLE_PRIVATE].onUnobserveHook(observer);
}
export function FiniteStateObservableGetState(instance) {
    return instance[FINITE_STATE_OBSERVABLE_PRIVATE].state;
}
export function FiniteStateObservableGetMode(instance) {
    return instance[FINITE_STATE_OBSERVABLE_PRIVATE].mode;
}
function PureFiniteStateObservableFactory(superClass) {
    if (!IsNotificationsObservableConstructor(superClass)) {
        throw new TypeError(`Expected NotificationsObservable constructor as superClass`);
    }
    const setSuperArgs = GetSetSuperArgsFunction(IsFactoryClass(superClass));
    return class FiniteStateObservable extends superClass {
        constructor(...args) {
            const [create, options] = args[0];
            let context;
            super(...setSuperArgs(args.slice(1), [
                (_context) => {
                    context = _context;
                    return {
                        onObserved: (observer) => {
                            FiniteStateObservableOnObserved(this, observer);
                        },
                        onUnobserved: (observer) => {
                            FiniteStateObservableOnUnobserved(this, observer);
                        },
                    };
                }
            ]));
            ConstructFiniteStateObservable(this, context, create, options);
        }
        get state() {
            return FiniteStateObservableGetState(this);
        }
        get mode() {
            return FiniteStateObservableGetMode(this);
        }
    };
}
export let FiniteStateObservable;
export function FiniteStateObservableFactory(superClass) {
    return MakeFactory(PureFiniteStateObservableFactory, [], superClass, {
        name: 'FiniteStateObservable',
        instanceOf: FiniteStateObservable,
        waterMarks: [IS_COMPLETE_STATE_OBSERVABLE_CONSTRUCTOR],
    });
}
export function FiniteStateObservableBaseFactory(superClass) {
    return MakeFactory(PureFiniteStateObservableFactory, [NotificationsObservableFactory, ObservableFactory], superClass, {
        name: 'FiniteStateObservable',
        instanceOf: FiniteStateObservable,
        waterMarks: [IS_COMPLETE_STATE_OBSERVABLE_CONSTRUCTOR],
    });
}
FiniteStateObservable = class AFiniteStateObservable extends FiniteStateObservableBaseFactory(BaseClass) {
    constructor(create, options) {
        super([create, options], [], []);
    }
};
//# sourceMappingURL=implementation.js.map